import { render } from "./ofertas_lab.vue?vue&type=template&id=a0c72c2c"
import script from "./ofertas_lab.vue?vue&type=script&lang=js"
export * from "./ofertas_lab.vue?vue&type=script&lang=js"

import "./ofertas_lab.vue?vue&type=style&index=0&id=a0c72c2c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__